import styles from "./styles.module.scss";
import { useContext, useState, useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";

import { DropdownButtonsProps } from "./types";
import { MergedColumnType } from "../table/utils/types";
import { request } from "../../../services";
import { ModalContext } from "../../../contexts/modal/index.context";
import { TranslationContext } from "../../../contexts/translation/index.context";
import { SessionContext } from "../../../contexts/session/index.context";
//Components
// import Modal from "../../../components/ui/modal";
import Popconfirm from "../../../components/ui/popconfirm";
import MoveDataForm from "../../../components/forms/move-data";
import SendMailForm from "../../../components/forms/send-mail";
//UI
import Dropdown from "antd/lib/dropdown";
import Button from "antd/lib/button";
import Modal from "antd/lib/modal";
import Select from "antd/lib/select";
import type { MenuProps } from "antd/es/menu/menu";
//Icons
import MoreOutlined from "@ant-design/icons/MoreOutlined";
import PrinterOutlined  from "@ant-design/icons/PrinterOutlined";
import CopyOutlined  from "@ant-design/icons/CopyOutlined";

import checkBefore from '../../../helpers/selectionOfActions';

import message from "antd/lib/message";
import { wrapperDynamicRoutes } from "../../../helpers/dynamic-routes-menu";

export default function DropdownButtonsComponent(props: DropdownButtonsProps) {
  // console.log('KEY ', props);
  const location = useLocation();
  const { intl } = useContext(TranslationContext);
  const context = useContext(ModalContext);
  const { sessionData } = useContext(SessionContext);
  const isForSignature = props.url === "/documents/for-signature";
  const isForEmail = props.url === "/documents/electronic-mail";
  const isForResolutions = props.url === "/documents/resolutions";
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [routeId, setRouteId] = useState(undefined);
  const [selectData, setSelectData] = useState<MergedColumnType[]>([]);
  const [showCopyToTab, setShowCopyToTab] = useState<boolean>(true);
       
  const options = selectData.map((item) => ({
    value: item.id,
    label: item.name,
  }));

  const showModal = async () => {
      //Компонент перевірка на доступ до внесення даних чи змін
    let accessRights = await checkBefore(location.pathname, props.url, 'copy-to-tab');
    if (!accessRights) {
      message.error(intl("you-do-not-have-access-rights"));
        return;
    }
    setIsModalOpen(true);
  }

  const handleOk = async () => {
    await request(
      `${location.pathname.split("/").slice(0, 2).join("/")}/addtoroute`,
      {
        method: "post",
        body: { id: sessionData.bta_documents_id, routeId },
        cancelTokenKey: "addtoroute",
      }
    );
    setIsModalOpen(false);
  };
  const handleCancel = () => setIsModalOpen(false);

  const fetchData = async () => {
    const content = (
      await request(
        `${location.pathname.split("/").slice(0, 2).join("/")}/getroutes`,
        {
          method: "get",
          cancelTokenKey: "getroutes",
        }
      )
    )?.content;
    setSelectData(content || []);
  };

  const handleChange = (value: any) => {
    setRouteId(value?.value);
  };

      //Компонент перевірка на доступ до внесення даних чи змін

  const handlePrintClick = async () => {
  let accessRights = await checkBefore(location.pathname, props.url, 'print');
  if (!accessRights) {
      message.error(intl("you-do-not-have-access-rights"));
    return;
  }
};

const isBlockedByUrl = (url?: string) => {
  const blocked: string[] = ["/documents/electronic-mail", "/documents/resolutions", "/documents/for-signature", "/documents/resolutions"];
  return !!url && blocked.includes(url);
};

// const runIdRef = useRef(0);

useEffect(() => {
  // const myRunId = ++runIdRef.current;
  (async () => {
    const shouldHideByDynamic = await wrapperDynamicRoutes(location.pathname);
    // if (runIdRef.current !== myRunId) return;
    // console.log("dynamic ", shouldHideByDynamic)
    const blocked = isBlockedByUrl(props.url);
    // console.log("dynamic ", blocked)
    // const canShow = !blocked && !shouldHideByDynamic;
    if(blocked === true) {
      setShowCopyToTab(false)
    }
    if (shouldHideByDynamic === true) {
      setShowCopyToTab(false)
    }
        // console.log('[btn] path=', location.pathname,
        //         'hideDynamic=', shouldHideByDynamic,
        //         'blocked=', blocked,
        //         'runId=', myRunId);

    // if (alive) setShowCopyToTab(canShow);
  })();

}, [location.pathname, props.url]);

// const showBtnToDynamic = async() => await wrapperDynamicRoutes(location.pathname);

// const compresionUrlForBtnCopyToTab = (): boolean=> {
//   const arr: string[] = ["/documents/electronic-mail", "/documents/resolutions"];

//     if(props.url && arr.includes(props.url)) {
//       // console.log("includes url ", arr.includes(props.url))
//       return false
//     }
//   return true
// };

  const items: MenuProps["items"] = [
    // {
    //   key: "1",
    //   label: (
    //     <a
    //       target="_blank"
    //       rel="noopener noreferrer"
    //       href={`${location.pathname}-view`}
    //     >
    //       {props.intl("view")}
    //     </a>
    //   ),
    // },
    ...(!isForSignature 
      ? [
        {
          key: "2",
          label: <Popconfirm name="remove" />,
        },
      ]
    : []),
    // {
    //   key: "3",
    //   label: (
    //     <Modal okText={props.intl("ok")} name={props.intl("move")}>
    //       <MoveDataForm intl={props.intl} />
    //     </Modal>
    //   ),
    // },
    // {
    //   key: "4",
    //   label: (
    //     <Modal okText={props.intl("ok")} name={props.intl("send-mail")}>
    //       <SendMailForm intl={props.intl} />
    //     </Modal>
    //   ),
    // },
    ...(!isForEmail ?[
          {
            key: "5",
            label:(
              <div className={styles["button-text"]}>
                <Button className={styles["button-text"]} 
                  disabled={context.disabled.edit} 
                  icon={<PrinterOutlined />}
                  onClick={handlePrintClick}
                  > 
                  {intl("printing")}
                </Button>
              </div>
            ),
          },
        ]
      : []),
      // =========================== isForResolutions Додано по задачі 28533
    ...(showCopyToTab  ? [ 
          {
            key: "6",
            label: (
                <div className={styles["button-text"]}>
                <Button
                  className={styles["button-text"]}
                  disabled={context.disabled.edit}
                  onClick={showModal}
                  icon={<CopyOutlined />}
                >
                  {intl("copy-to-tab")}
                </Button>
              </div>
            ),
          },
        ]
      : []),
  ];

  return (
    <>
      <Dropdown menu={{ items }} trigger={["click"]} placement="bottomRight">
        <Button>
          <MoreOutlined />
        </Button>
      </Dropdown>
      <Modal open={isModalOpen} onOk={handleOk} onCancel={handleCancel}>
        <Select
          labelInValue
          style={{ width: "100%" }}
          onChange={handleChange}
          onDropdownVisibleChange={fetchData}
          options={options}
          allowClear
        />
      </Modal>
    </>
  );
}
